import React from "react";
import styles from "./OurHotel.module.scss";
import Divider from "@components/Divider";
import Image from "@components/Image";
import cx from "classnames";
import CardBrand from "./CardBrand";
import Button from "@components/Button";
import Link from "@components/Link";
import _ from "lodash";
import { useTranslationContext } from "@providers/TranslationProvider";
import { useRouteContext } from "@providers/RouteProvider";
import { contactPage } from "@utils/helper";
import { usePageContext } from "@providers/PageProvider";

const View = () => {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  const { pageData } = usePageContext();
  const ourHotels = contactPage.formatHotel(pageData);
  const bannerFooter = contactPage.formatBannerFooter(pageData);
  const CARDS = _.map(ourHotels.hotels, (item: any) => {
    return {
      title: item.title,
      content: (
        <>
          {item.address}
          <br />
          <div>
            {i18n.t("Form.labelPhone")}
            {` `} <Link href={`tel:${item.phone}`}>{item.phone}</Link> <br />
          </div>
          <div>
            <Link href={`mailto:${item.email}`}>{item.email}</Link>
          </div>
        </>
      ),
      button: (
        <Button
          onClick={() => {
            router.open(item.button.buttonLink);
          }}
          type="text"
          color="black"
          label={item.button.buttonName}
        />
      ),
    };
  });
  return (
    <section data-scroll-section className={cx(styles.section)}>
      <div className={"inner"}>
        <Divider
          labelProps={{ className: styles.label }}
          label={
            <>
              <div className={styles.title}>
                {_.get(ourHotels, "title", "")}
              </div>
            </>
          }
        />
      </div>
      <div className={cx("inner-large mx-auto", styles.content)}>
        {_.map(CARDS, (item: object, index: number) => (
          <CardBrand {...item} key={`card_${index}`} />
        ))}
      </div>
      <div className={styles.tail}>
        <Image
          scale={1.2}
          wrapperProps={{ className: styles.image }}
          src={_.get(bannerFooter, "image.src") ?? "/contact/tail.jpg"}
          alt={_.get(bannerFooter, "image.alt") ?? "tail"}
          layout="fill"
          objectFit="cover"
        />
      </div>
    </section>
  );
};
export default View;
